import useDelayedQuery from '@hooks/useDelayedQuery.js';
import useTwitchRequest from '@hooks/useTwitchRequest.js';
import { useCallback, useEffect, useRef } from 'preact/hooks';
import { useQueryClient } from '@tanstack/react-query';

export const useTwitchCampaigns = (config, disabled) => {
  const request = useTwitchRequest({
    twitchAccessToken: config.twitchAccessToken,
    tokenValidated: !disabled,
  });

  const twitchUsername = config.twitchUsername;
  const disabledRef = useRef(disabled);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!disabled && disabledRef.current) {
      disabledRef.current = false;
      queryClient
        .invalidateQueries({
          queryKey: ['twitch', twitchUsername, 'getCampaigns'],
        })
        .then();
    } else if (disabled && !disabledRef.current) {
      disabledRef.current = true;
    }
  }, [disabled, queryClient, twitchUsername]);

  const { data: campaigns, isFetching: campaignsLoading } = useDelayedQuery({
    queryKey: ['twitch', twitchUsername, 'getCampaigns'],
    placeholderData: undefined,
    enabled: !disabled,
    queryFn: async () => {
      if (!config.twitchBroadcasterID || config.twitchBroadcasterID === 'null')
        return [];

      try {
        return await request('/getUserCampaigns', {
          broadcasterID: config.twitchBroadcasterID,
        }).then((result) => {
          if (result.success) return result.data.filter(campaign => campaign['charity_name'].includes('St. Jude'));
          return [];
        });
      } catch (err) {
        throw new Error(err.message);
      }
    },
  });


  const deleteCampaign = useCallback((campaignID) => {
    try {
      return request(`/deleteUserCharityCampaign/${campaignID}`, null, 'DELETE').then((result) => {
        if (result && result.success) return result.data;
        return [];
      });
    } catch (err) {
      throw new Error(err.message);
    }
  }, [request])

  const writeCampaign = useCallback((campaign) => {
    try {
      return request('/writeUserCharityCampaign', campaign).then((result) => {
        if (result && result.success) return result.data;
        return [];
      });
    } catch (err) {
      throw new Error(err.message);
    }
  }, [request])

  return { campaigns, campaignsLoading, writeCampaign, deleteCampaign };
};
